<!--  -->
<template>
  <div class="skeleton">
    <div class="skeleton-header">
        <div class="center"></div>
    </div>
    <div class="skeleton-part1">
      <div class="skeleton-part1-center">
        <p
          v-for="item in [200,325]"
          :key="item"
          :style="{width:item/100+'rem'}"></p>
      </div>
    </div>
    <div class="skeleton-part2 mt5">
      <div class="skeleton-part2-center">
        <p
          v-for="item in [355,250,150]"
          :key="item"
          :style="{width:item/100+'rem'}"></p>
      </div>
    </div>
    <ul class="skeleton-part3 mt5">
      <li v-for="i in 5" :key="i">
        <div class="left"></div>
        <div class="right">
          <p v-for="i in [226,161,110]" :key="i" :style="{width:i/100+'rem'}"></p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {},

  props: {},

  data () {
    return {
    }
  },

  computed: {},

  watch: {},

  created () {},

  methods: {}
}

</script>
<style lang='scss' scoped>
.skeleton{
  @include skeletonBlink();
  height: calc(100vh - 50px);
  overflow: hidden;
  position: relative;
  &-header{
    height: 45px;
    width: 100%;
    background: var(--APP_skeleton_color);
    @include center();
    .center{
      width: 300px;
      height: 24px;
      border-radius: 3px;
      background:rgba(243,242,242,1);
    }
  }
  &-part1{
    width: 100%;
    box-sizing: border-box;
    height: 80px;
    padding: 12px 10px;
    background: var(--APP_skeleton_background_color);
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    display: flex;
    &-center{
      flex: 1;
      p{
        height: 15px;
        background: var(--APP_skeleton_color);
        border-radius: 2px;
      }
      display: flex;
      justify-content: space-around;
      flex-direction: column;
    }
  }
  &-part2{
    width: 100%;
    box-sizing: border-box;
    height: 160px;
    padding: 12px 10px;
    background: var(--APP_skeleton_background_color);
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    display: flex;
    &-center{
      flex: 1;
      p{
      height: 15px;
      background: var(--APP_skeleton_color);
        border-radius: 2px;
    }
    display: flex;
      justify-content: space-around;
    flex-direction: column;
    }
  }
  &-part3{
    background: var(--APP_skeleton_background_color);
    border-radius: 10px;
    width: 100%;
    li{
      height: 110px;
      display: flex;
      box-sizing: border-box;
      padding: 15px 0 10px 10px;
      width: 100%;
      position: relative;
      .left{
        width: 85px;
        height: 85px;
        border-radius: 3px;
        background: var(--APP_skeleton_color);
      }
      .right{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom: 15px;
        margin-left: 27px;
        p{
          height: 15px;
          background: var(--APP_skeleton_color);
        }
      }
      .btn{
        position: absolute;
        bottom: 15px;
        right: 10px;
        display: inline-block;
        height: 24px;
        width: 78px;
        background: var(--APP_skeleton_color);
        border-radius: 3px;
      }
      &:not(:last-child){
        .right{
          border-bottom: 1px solid var(--APP_skeleton_color);
        }
      }
    }
  }
}
</style>
